/**
 * Strapi may return absolute URLs (e.g. Cloudinary) or paths like /uploads/...
 */
export function resolveStrapiMediaUrl(url) {
  if (!url || typeof url !== "string") return null;
  if (/^https?:\/\//i.test(url)) return url;
  const base = (process.env.REACT_APP_API_URL ?? "").replace(/\/$/, "");
  if (!base) return url;
  const path = url.startsWith("/") ? url : `/${url}`;
  return `${base}${path}`;
}
